import { thunkDragStart } from '@store/reducers/artboard/actionCreators'
import type { AppState } from '@store/types'
import {
  selectBlock,
  selectNode,
  selectSymbol,
} from '@storeOld/reducers/canvas/canvas'
import type React from 'react'
import type { RefObject } from 'react'
import { useDispatch } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import { DRAGGABLE_TYPE } from '../types'

const useOnDragStart = (
  ref: RefObject<any>,
  type: DRAGGABLE_TYPE,
  id: string,
  data: any,
  skipSelection = false
) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  return (e: React.MouseEvent) => {
    if (e.button !== 0) {
      return
    }

    if (ref && ref.current) {
      const currentRefClientRect = ref.current.getBoundingClientRect()

      if (type === DRAGGABLE_TYPE.BLOCK) {
        dispatch(selectBlock(e, id))
      }

      dispatch(
        thunkDragStart({
          elementPosition: {
            x: currentRefClientRect.left,
            y: currentRefClientRect.top,
          },
          startPosition: {
            x: e.clientX,
            y: e.clientY,
          },
          dragged: {
            type,
            id,
            data,
          },
        })
      )

      if (type === DRAGGABLE_TYPE.PAGE && !skipSelection) {
        // @todo implement action
        dispatch(selectNode(e, id))
      }

      // A library symbol keeps its own selection in the sidebar: the canvas
      // symbol selection (and its toast) is for project symbols only.
      if (type === DRAGGABLE_TYPE.SYMBOL && !data?.library) {
        // @todo implement action
        dispatch(selectSymbol(e, id))
      }
    }
  }
}

export default useOnDragStart
